import React from 'react';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';
import { CollectorAndReleaseDetails, ImageWrapper, Row, RowTitle } from './shared';

export const AllArtistCollectorsRow = ({
  artistName,
  avatarUrl,
}: {
  artistName: string;
  avatarUrl: string;
}) => {
  return (
    <Row center>
      <ImageWrapper>
        <NextFutureImage alt="artist avatar" src={avatarUrl} width={40} height={40} />
      </ImageWrapper>
      <CollectorAndReleaseDetails>
        <RowTitle>All of {artistName}'s collectors</RowTitle>
      </CollectorAndReleaseDetails>
    </Row>
  );
};
